var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8F4FC"
    },
    d: "M345.169,152.449c0-31.721-25.807-57.528-57.528-57.528s-57.528,25.807-57.528,57.528h34.517 c0-12.688,10.323-23.011,23.011-23.011c12.688,0,23.011,10.323,23.011,23.011c0,12.688-10.323,23.011-23.011,23.011H46.022v34.517 H287.64C319.361,209.978,345.169,184.17,345.169,152.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1E5F5"
    },
    d: "M431.461,106.427c-34.893,0-63.281,28.388-63.281,63.281c0,25.377,20.646,46.022,46.022,46.022 c25.377,0,46.022-20.646,46.022-46.022h-34.517c0,6.344-5.161,11.506-11.506,11.506s-11.506-5.161-11.506-11.506 c0-15.861,12.904-28.764,28.764-28.764c25.377,0,46.022,20.646,46.022,46.022s-20.646,46.022-46.022,46.022H0v34.517h431.461 c44.411,0,80.539-36.13,80.539-80.539S475.871,106.427,431.461,106.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4D8F1"
    },
    d: "M345.169,290.517H46.022v34.517h299.146c15.861,0,28.764,12.904,28.764,28.764 s-12.904,28.764-28.764,28.764s-28.764-12.904-28.764-28.764h-34.517c0,34.893,28.388,63.281,63.281,63.281 s63.281-28.388,63.281-63.281S380.062,290.517,345.169,290.517z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.cbd72d955ebb793b49b12742594d6aef.svg";
export { ForwardRef as ReactComponent };